import React from "react";
import RSS from "../assets/rosoftsavvy.png";
export default function Logo() {
  return <img src={RSS} alt="RSS Logo" width={40} height={"auto"} />;
}
